module.exports = __webpack_public_path__ + "static/media/backgroundTiling.3f438744.png";